import { createSelector } from 'reselect';

const selecttenantDomainFunctions = (state: any) => state.tenantDomainFunctions;


export const selecttenantDomainFunctionsCurrentItem = createSelector([selecttenantDomainFunctions], (tenantDomainFunctions) => tenantDomainFunctions.current);

export const selecttenantDomainFunctionsListItems = createSelector([selecttenantDomainFunctions], (tenantDomainFunctions) => tenantDomainFunctions.list);

export const selectItemById = (itemId: any) =>
    createSelector(selecttenantDomainFunctionsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selecttenantDomainFunctionsQueryItems = createSelector([selecttenantDomainFunctions], (tenantDomainFunctions) => tenantDomainFunctions.query);

export const selecttenantDomainFunctionsCreatedItem = createSelector([selecttenantDomainFunctions], (tenantDomainFunctions) => tenantDomainFunctions.create);

export const selecttenantDomainFunctionsUpdatedItem = createSelector([selecttenantDomainFunctions], (tenantDomainFunctions) => tenantDomainFunctions.update);

export const selecttenantDomainFunctionsReadItem = createSelector([selecttenantDomainFunctions], (tenantDomainFunctions) => tenantDomainFunctions.read);

export const selecttenantDomainFunctionsDeletedItem = createSelector([selecttenantDomainFunctions], (tenantDomainFunctions) => tenantDomainFunctions.delete);

export const selecttenantDomainFunctionsSearchedItems = createSelector([selecttenantDomainFunctions], (tenantDomainFunctions) => tenantDomainFunctions.search);

export const selecttenantDomainFunctionsItemsCount = createSelector([selecttenantDomainFunctions], (tenantDomainFunctions) => tenantDomainFunctions.count);

export const selecttenantDomainFunctionsItemsFilter = createSelector([selecttenantDomainFunctions], (tenantDomainFunctions) => tenantDomainFunctions.filter);